import React from "react";
import { getStorageUser } from "../../../helpers/api_helper";

const Columns = (addUpd, destroy) => {
  const authUser = getStorageUser();

  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      id: "color",
      name: "Color",
      width: "110px",
      cell: (row) =>
        row.color ? (
          <span className="d-flex align-items-center" style={{ gap: 6 }}>
            <span
              style={{
                width: 14,
                height: 14,
                borderRadius: 4,
                background: row.color,
                border: "1px solid #e9ebec",
              }}
            />
            <span style={{ fontSize: "11.5px" }}>{row.color}</span>
          </span>
        ) : (
          <span className="text-muted">—</span>
        ),
    },
    {
      id: "actions",
      name: "Acciones",
      width: "20%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar zona"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar zona"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];

  if (authUser.profile_id == 2) {
    columns = [
      {
        id: "ruta",
        name: "Ruta",
        selector: (row) => row.route?.name,
        sortable: true,
      },
      ...columns,
    ];
  }

  return columns;
};

export default Columns;
